//documents
const GET_DOCUMENTS = 'datahub/GET_DOCUMENTS';
const DOCUMENTS_SUCCESS = 'datahub/DOCUMENTS_SUCCESS';
const DOCUMENTS_ERROR = 'datahub/DOCUMENTS/ERROR';
const ORIGINAL_DOCUMENTS_DATA = 'datahub/ORIGINAL_DOCUMENTS_DATA';

const GET_DOCUMENT_DETAIL = 'datahub/GET_DETAIL';
const DOCUMENT_DETAIL_SUCCESS = 'datahub/GET_DOCUMENT_DETAIL_SUCCESS';
const DETAIL_PAGE_MUN = 'datahub/DETAIL_PAGE_MUN';

const SET_DOCUMENT_TYPES = 'datahub/SET_DOCUMENT_TYPES';

//categories
const GET_CATEGORIES = 'categories/GET_CATEGORIES';
const CATEGORIES_SUCCESS = 'categories/CATEGORIES_SUCCESS';

//advanced search
const SET_SEARCH = 'search/SET_SEARCH';

export default {
  GET_DOCUMENTS,
  DOCUMENTS_SUCCESS,
  DOCUMENTS_ERROR,
  ORIGINAL_DOCUMENTS_DATA,

  SET_DOCUMENT_TYPES,

  GET_DOCUMENT_DETAIL,
  DOCUMENT_DETAIL_SUCCESS,
  DETAIL_PAGE_MUN,

  GET_CATEGORIES,
  CATEGORIES_SUCCESS,

  SET_SEARCH
};



// WEBPACK FOOTER //
// ./src/datahub/types.js